/**
 * Show a floating reward notification
 * @param {number} coins - Coins earned
 * @param {number} xp - XP earned
 * @param {number} bondingPoints - Bonding points earned
 */
export const showRewardNotification = (coins = 0, xp = 0, bondingPoints = 0) => {
  // Create a floating reward notification
  const notification = document.createElement('div');
  notification.style.cssText = `
    position: fixed;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    background: linear-gradient(135deg, #372F2F 0%, #FFA500 100%);
    color: #8B4513;
    padding: 20px 30px;
    border-radius: 15px;
    font-size: 18px;
    font-weight: bold;
    box-shadow: 0 10px 30px rgba(0,0,0,0.3);
    z-index: 10000;
    animation: rewardPop 0.5s ease-out;
    text-align: center;
  `;
  
  const rewards = [];
  if (coins > 0) {
    rewards.push(`<img src="https://customer-assets.emergentagent.com/job_virtual-corral-1/artifacts/12b5y0cy_B2C99D99-3648-4E18-8993-68DCE291F164.png" alt="Coin" style="width: 16px; height: 16px; display: inline; vertical-align: middle;" /> +${coins} Coins`);
  }
  if (xp > 0) {
    rewards.push(`⭐ +${xp} XP`);
  }
  if (bondingPoints > 0) {
    rewards.push(`💙 +${bondingPoints} Bond`);
  }
  
  notification.innerHTML = `
    <div style="font-size: 32px; margin-bottom: 10px;">🎉</div>
    <div>Reward Earned!</div>
    <div style="font-size: 24px; margin-top: 10px;">
      ${rewards.join(' | ')}
    </div>
  `;
  
  // Add keyframes if they don't exist
  if (!document.getElementById('reward-animations')) {
    const style = document.createElement('style');
    style.id = 'reward-animations';
    style.textContent = `
      @keyframes rewardPop {
        0% {
          transform: translate(-50%, -50%) scale(0.5);
          opacity: 0;
        }
        50% {
          transform: translate(-50%, -50%) scale(1.1);
        }
        100% {
          transform: translate(-50%, -50%) scale(1);
          opacity: 1;
        }
      }
      @keyframes rewardFade {
        0% {
          transform: translate(-50%, -50%) scale(1);
          opacity: 1;
        }
        100% {
          transform: translate(-50%, -50%) scale(0.8);
          opacity: 0;
        }
      }
    `;
    document.head.appendChild(style);
  }
  
  document.body.appendChild(notification);
  
  // Remove after animation
  setTimeout(() => {
    notification.style.animation = 'rewardFade 0.5s ease-out';
    setTimeout(() => notification.remove(), 500);
  }, 2000);
};
